import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import referralService from "./referralService";

interface ReferralI {
  name: string;
  mobileNumber: string;
  email: string;
}

interface referralState {
  isLoading: boolean;
  isSuccessful: boolean;
  referral: ReferralI;
}

const initialState: referralState = {
  isLoading: false,
  isSuccessful: false,
  referral: {
    name: "",
    mobileNumber: "",
    email: "",
  },
};

export const referral = createAsyncThunk("referral", async (data: any) => {
  try {
    const response = await referralService.referral(data);
    if (response.status === 200) {
      toast.success(response?.data.message);
    } else {
      toast.error(response?.data?.statusMessage);
    }
    return response.data;
  } catch (error) {
    const err = error as AxiosError<{ message: string }>;
    toast.error(err.response?.data.message);
    return err?.response?.data;
  }
});

export const referralSlice = createSlice({
  name: "feedback",
  initialState,
  reducers: {
    noTract: () => {},
  },
  extraReducers: (builder) => {
    builder
      .addCase(referral.pending, (state, action) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(referral.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccessful: true,
        };
      })
      .addCase(referral.rejected, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccessful: false,
          //error: action.payload.message,
        };
      });
  },
});

export default referralSlice.reducer;
